import * as Types from '../../../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddProfilePreferenceMutationVariables = Types.Exact<{
  suid: Types.Scalars['String']['input'];
  sentiment: Types.JobSeekerProfileStructuredDataSentiment;
}>;


export type AddProfilePreferenceMutation = { __typename?: 'Mutation', addJobSeekerProfileStructuredDataPreferenceAttributes?: { __typename?: 'AddJobSeekerProfileStructuredDataPreferenceAttributesPayload', ignore: 'AddJobSeekerProfileStructuredDataPreferenceAttributesPayload', preference?: { __typename?: 'AddJobSeekerProfileStructuredDataPositivePreferenceAttributesPayload', attributes: Array<{ __typename?: 'JobSeekerProfileStructuredDataAttribute', id: string, suid: string, sentiment: Types.JobSeekerProfileStructuredDataSentiment }> } | null, dislikedPreference?: { __typename?: 'AddJobSeekerProfileStructuredDataDislikedPreferenceAttributesPayload', attributes: Array<{ __typename?: 'JobSeekerProfileStructuredDataAttribute', id: string, suid: string, sentiment: Types.JobSeekerProfileStructuredDataSentiment }> } | null } | null };


export const AddProfilePreferenceDocument = gql`
    mutation AddProfilePreference($suid: String!, $sentiment: JobSeekerProfileStructuredDataSentiment!) {
  addJobSeekerProfileStructuredDataPreferenceAttributes(
    input: {attributes: [{suid: $suid, sentiment: $sentiment}]}
  ) {
    ignore: __typename
    preference {
      attributes {
        id
        suid
        sentiment
      }
    }
    dislikedPreference {
      attributes {
        id
        suid
        sentiment
      }
    }
  }
}
    `;
export type AddProfilePreferenceMutationFn = Apollo.MutationFunction<AddProfilePreferenceMutation, AddProfilePreferenceMutationVariables>;

/**
 * __useAddProfilePreferenceMutation__
 *
 * To run a mutation, you first call `useAddProfilePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProfilePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProfilePreferenceMutation, { data, loading, error }] = useAddProfilePreferenceMutation({
 *   variables: {
 *      suid: // value for 'suid'
 *      sentiment: // value for 'sentiment'
 *   },
 * });
 */
export function useAddProfilePreferenceMutation(baseOptions?: Apollo.MutationHookOptions<AddProfilePreferenceMutation, AddProfilePreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProfilePreferenceMutation, AddProfilePreferenceMutationVariables>(AddProfilePreferenceDocument, options);
      }
export type AddProfilePreferenceMutationHookResult = ReturnType<typeof useAddProfilePreferenceMutation>;
export type AddProfilePreferenceMutationResult = Apollo.MutationResult<AddProfilePreferenceMutation>;
export type AddProfilePreferenceMutationOptions = Apollo.BaseMutationOptions<AddProfilePreferenceMutation, AddProfilePreferenceMutationVariables>;